module.exports = __webpack_public_path__ + "img/biomakers_logo.e5fb08a7.png";